<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <upload-file
      :files="uploadingFiles"
      :icons="fileIcons"
      :rules="rules"
      v-on:add-files="addUploadingFiles"
      v-on:remove-file="removeUploadingFile"
      :accept="file_accept"
      :hideDetails="hideDetails"
      :maxsize="maxsize"
    ></upload-file>
    <span v-if="errorCount > 0" class="error--text">
      <small>{{ $t("documents.invalidFileMsg", { count: errorCount }) }}</small>
    </span>
    <span v-if="checkValidMessagePriority" class="error--text">
      <small>{{ $t("documents.lblMax10MB") }}</small>
    </span>
  </v-form>
</template>

<script>
import UploadFile from "./documents/UploadFile.vue";
import { fileIcons, MAX_EMAIL_ATTACHMENT_SIZE } from "../utils/constant";

export default {
  name: "UploadEmailAttachment",
  components: { UploadFile },
  data() {
    return {
      isAllFilesSizeMoreThen10MB: false,
      maxsize: MAX_EMAIL_ATTACHMENT_SIZE,
      valid: false,
      uploadingFiles: [],
      fileIcons,
      hideDetails: false,
      chunkUploadFilesList: [],
      rules: [],
      file_accept: [
        "image/png",
        "image/jpeg",
        "image/gif",
        "image/bmp",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-fontobject",
        "application/vnd.ms-fontobject",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "text/plain",
        "application/zip",
        "application/x-zip",
        "application/octet-stream",
        "application/x-zip-compressed",
        "application/vnd.rar",
        "application/x-rar-compressed",
        "multipart/x-zip",
        "application/gzip",
        "image/svg+xml",
        "application/vnd.ms-excel.sheet.macroEnabled.12"
      ],
    };
  },
  computed: {
    errorCount() {
      return this.uploadingFiles.filter(
        (item) => !this.checkStatus(item).status
      ).length;
    },
    checkValidMessagePriority() {
      return this.errorCount === 0 && this.isAllFilesSizeMoreThen10MB;
    },
  },
  watch: {
    errorCount(value) {
      this.$emit("valid", value <= 0);
    },
  },
  methods: {
    checkStatus,
    addUploadingFiles,
    removeUploadingFile,
    updateFileStatus,
  },
};

function checkStatus(file) {
  const isFileAccepted = this.file_accept.includes(file.type);

  return {
    filename: file.fileName,
    status: isFileAccepted,
    message: isFileAccepted
      ? "Success"
      : this.$t("fileErrorMsg", { filename: file.fileName }),
  };
}

function updateFileStatus() {
  this.isAllFilesSizeMoreThen10MB = calculateAllFilesSize(this.uploadingFiles);
  this.$emit("valid", !this.isAllFilesSizeMoreThen10MB);
  this.$emit("attachments", this.uploadingFiles);
}

function addUploadingFiles(files) {
  this.uploadingFiles.push(...Array.from(files));
  this.updateFileStatus();
}

function removeUploadingFile(index) {
  this.uploadingFiles.splice(index, 1);
  this.updateFileStatus();
}

function calculateAllFilesSize(files) {
  const totalSize = files.reduce((sum, file) => sum + file.size, 0);
  return totalSize > MAX_EMAIL_ATTACHMENT_SIZE;
}
</script>

<style>
</style>